import Avatar from "@material-ui/core/Avatar";
import Chip, { ChipProps } from "@material-ui/core/Chip";
import React, { CSSProperties, ReactElement } from "react";
import { Job } from "models/job/Job";
import { useTranslation } from "react-i18next";
import IconError from "@material-ui/icons/Error";
import IconCheckCircle from "@material-ui/icons/CheckCircle";
import IconLoop from "@material-ui/icons/Loop";
import IconArchive from "@material-ui/icons/Archive";

export type JobStateChipProps = {
  job: Job;
} & ChipProps;

const state: {
  [status: string]: {
    icon: ReactElement;
    chipStyle: CSSProperties;
    avatarStyle: CSSProperties;
  };
} = {
  failed: {
    icon: <IconError style={{ color: "#FFF" }} />,
    chipStyle: { backgroundColor: "#de4b4b", color: "#FFF" },
    avatarStyle: { backgroundColor: "#903131" }
  },
  successful: {
    icon: <IconCheckCircle style={{ color: "#FFF" }} />,
    chipStyle: { backgroundColor: "#4fba2c", color: "#FFF" },
    avatarStyle: { backgroundColor: "#39871f" }
  },
  "in-progress": {
    icon: <IconLoop className="spin" style={{ color: "#FFF" }} />,
    chipStyle: { backgroundColor: "#e0dd25", color: "#FFF" },
    avatarStyle: { backgroundColor: "#adab1c" }
  },
  pending: {
    icon: <IconLoop className="spin" style={{ color: "#FFF" }} />,
    chipStyle: { backgroundColor: "#e0dd25", color: "#FFF" },
    avatarStyle: { backgroundColor: "#adab1c" }
  },
  unknown: {
    icon: <IconArchive style={{ color: "#FFF" }} />,
    chipStyle: { backgroundColor: "#989898", color: "#FFF" },
    avatarStyle: { backgroundColor: "#616060" }
  }
};

export const JobStateChip = ({ job, ...props }: JobStateChipProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(`job.state.${job.state}`)}
      clickable={true}
      style={state[job.state].chipStyle}
      avatar={
        <Avatar style={state[job.state].avatarStyle}>
          {state[job.state].icon}
        </Avatar>
      }
      {...props}
    />
  );
};
